<template>
  <v-dialog v-model="$parent.popup.isVisible" persistent width="400">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{$parent.popup.title}}</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs12>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              שם תוכנית
            </v-flex>
            <v-flex xs9>
              <input type="text" v-model="$parent.popup.data.Name" />
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              תיאור תוכנית בנייה
            </v-flex>
            <v-flex xs9>
              <textarea type="text" rows="3" v-model="$parent.popup.data.Info" style="width: 200px;" />
            </v-flex>
          </v-layout>
          <v-layout row wrap style="padding: 20px 10px 10px 10px;">
            <v-flex xs3 right>
              פרויקט
            </v-flex>
            <v-flex xs9>
              <span class="custom-dropdown custom-dropdown--white" style="width: 200px;">
                <select v-model="$parent.popup.data.ProjectKey" class="custom-dropdown__select custom-dropdown__select--white" @change="setProjectName">
                  <!--<option value="">בחר פרויקט</option>-->
                  <option v-for="project in projects" :value="project['.key']">{{project.Name}}</option>
                </select>
              </span>
            </v-flex>
          </v-layout>
          <v-flex row wrap style="padding: 10px 10px 10px 10px;">
            <span class="error" v-show="error">* {{error}}</span>
          </v-flex>
        </v-flex>
        <!--<v-flex xs6>
          <v-flex style="height: 75%; position: relative;">
            <img v-if="hasFiles" class="imgPreview" :src="activeImage" />
            <img v-else class="imgPreview" src="../assets/no_image.png" />
            <v-icon v-if="hasImages" @click="removeImage" class="btnIcon mr-2 btnRemoveImage" v-tooltip:bottom="{ html: 'מחיקה' }">close</v-icon>
          </v-flex>
          <v-flex style="text-align: right;">
            
          </v-flex>
          <v-flex style="vertical-align: bottom; text-align: right;">
            <label class="file-select">
              העלאת קובץ (PDF)
              <v-icon v-show="!showProgress" right class="green--text" v-tooltip:bottom="{ html: 'העלאת קובץ (PDF)' }">cloud_upload</v-icon>
              <v-progress-circular v-show="showProgress" indeterminate color="primary"></v-progress-circular>
              <input type="file" @change="upload" />
            </label>
          </v-flex>
        </v-flex>-->
      </v-layout>
      <hr />
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex row wrap style="padding: 0px 50px;">
          אחרי שמירת שם ותיאור תוכנית בניית ניתן לצרף מסמכים לתוכנית
        </v-flex>
      </v-layout>
        <hr />
        <v-flex v-if="canEdit" actions style="padding-bottom: 20px;">
          <v-btn outline small class="green green--text ml-3" @click.native="save">
            שמירה
            <v-icon left>check</v-icon>
          </v-btn>
          <v-btn outline small class="red red--text ml-2" @click.native="cancel">
            ביטול
            <v-icon left>block</v-icon>
          </v-btn>
        </v-flex>
        <v-flex v-else actions style="padding-bottom: 20px;">
          <v-btn outline small class="red red--text ml-2" @click.native="cancel">
            סגור חלון
            <v-icon left>cancel</v-icon>
          </v-btn>
        </v-flex>
</v-card>
  </v-dialog>
</template>

<script>
  import noImg from '../assets/no_image.png';

  import { db, storage } from '../firebase';
  var projectsRef = db.ref('Projects');
  var plansRef = db.ref('Plans');

  export default {
    name: 'PopupPlan',
    data() {
      return {
        error: '',
        selectedColor: '#ffffff',
        showFile: false,
        showProgress: false,
        logoUrl: '',
        activeImage: noImg,
        hasImages: false,
        projects: []
      }
    },
    firebase: function () {
      var vm = this;
      return {
        projects: vm.$root.isAdmin ? projectsRef.orderByKey() : projectsRef.orderByChild("UserKey").equalTo(vm.$root.user['.key'])
      }
    },
    created() {
      this.$Log("Vue [PopupPlan] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupPlan] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupPlan] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupPlan] is updated ...");
    },
    computed: {
      canEdit() {
        return true;
      },
      hasFiles() {
        if (this.$parent.popup.data.Files != undefined && this.$parent.popup.data.Files.length > 0) {
          return true;
        }
        else {
          return false;
        }
      }
    },
    methods: {
      setProjectName() {
        for (var i = 0; i < this.projects.length; i++) {
          if (this.projects[i]['.key'] == this.$parent.popup.data.ProjectKey) {
            this.$parent.popup.data.ProjectName = this.projects[i].Name;
            break;
          }
        }
      },
      setAddress(place) {
        this.$Log("setPlace(place) >>> " + JSON.stringify(place));
        this.$parent.popup.data.Location = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
      },
      isValid(callback) {
        if (this.$parent.popup.data.Name.trim().length <= 0) return false;
        if (this.$parent.popup.data.Info.trim().length <= 0) return false;
        if (this.$parent.popup.data.ProjectKey === undefined) return false;
        if (this.$parent.popup.data.ProjectName.trim().length <= 0) return false;
        if (this.$parent.popup.data.ProjectKey.trim().length <= 0) return false;
        
        return true;
      },
      save() {
        var vm = this;
        vm.error = "";
        if (vm.isValid()) {
          if (vm.$parent.popup.isEdit) {
            vm.$parent.update();
          }
          else {
            vm.$parent.insert();
          }
          vm.reset();
        }
        else {
          vm.error = "נא למלא את כל השדות!"
        }
      },
      cancel() {
        this.reset();
      },
      reset() {
        this.error = "";
        this.$parent.popup = {
          isVisible: false,
          isEdit: false,
          title: '',
          data: {
            '.key': '',
            Name: '',
            Info: '',
            UserKey: '',
            ProjectKey: '',
            ProjectName: '',
            //Files: [],
            CreateDate: '',
            UpdateDate: '',
          },
        };
        this.activeImage = noImg;
      },
      upload(e) {
        this.$emit('#fileUpload', e.target.files[0]);
        var files = e.target.files || e.dataTransfer.files;

        if (!files.length) return;

        var vm = this;

        var file = files[0];
        var image = new Image();
        var reader = new FileReader();

        reader.onload = (ev) => {
          vm.logoUrl = ev.target.result;
        };
        reader.readAsDataURL(file);

        vm.showFile = true;

        var storageRef = storage.ref('plans/' + file.name);

        var task = storageRef.put(file);

        vm.showProgress = true;

        task.on('state_changed',
          function progress(snap) {
            //vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100;
          },
          function error(err) {
            vm.showFile = false;
            vm.showProgress = false;
          },
          function complete() {
            vm.showProgress = false;
            vm.logoUrl = task.snapshot.downloadURL;
            vm.$parent.popup.data.Images.push(task.snapshot.downloadURL);
            if (vm.activeImage == noImg) {
              vm.activeImage = vm.$parent.popup.data.Images[0];
            }
          }
        );
      },
      removeImage() {

      }
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// PopupPlan.vue?2ec40574